'use client'
import Link from 'next/link'
import DownloadAppPopover from './download-app-popover'

export default function Header() {
  return (
    <header className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="flex justify-between items-center h-20">
          <Link href="/san-pham" className="group flex items-center gap-2.5">
            {/* next/image blocks local SVGs by default (dangerouslyAllowSVG
                is unset in next.config.ts) — plain <img> avoids widening
                that project-wide security setting for one logo asset. */}
            <img
              src="/logo.svg"
              alt="BuyXShare"
              className="h-14 w-auto transition-transform duration-300 group-hover:scale-105"
            />
          </Link>

          {/* Desktop Navigation */}
          {/* <nav className="hidden md:flex items-center space-x-8">
            <Link href="/" className="text-gray-700 hover:text-blue-600 transition-colors font-medium">
              Trang chủ
            </Link>
            <Link href="/san-pham" className="text-gray-700 hover:text-blue-600 transition-colors font-medium">
              Sản phẩm
            </Link>
            <Link href="/about" className="text-gray-700 hover:text-blue-600 transition-colors font-medium">
              Giới thiệu
            </Link>
            <Link href="/contact" className="text-gray-700 hover:text-blue-600 transition-colors font-medium">
              Liên hệ
            </Link>
          </nav> */}

          {/* Actions */}
          <div className="flex items-center space-x-2 md:space-x-4">
            <div className="hidden md:flex items-center">
              <DownloadAppPopover />
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

